<div>
  <h3>{{ 'label.FutureAnnouncements' | translate }}</h3>
  <p-table
    [value]="announcements"
    [rowHover]="false"
    [lazy]="true"
    showGridlines
    (onLazyLoad)="load($event)"
    expandableRows="true"
    [style]="{ width: '900px' }"
    [resizableColumns]="true"
    columnResizeMode="expand"
    dataKey="date"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 35px"></th>
        <th>Date</th>
        <th>Ann. renew</th>
        <th>Ann. future</th>
      </tr>
    </ng-template>

    <ng-template
      #body
      let-announcement
      let-expanded="expanded"
      let-columns="columns"
    >
      <tr>
        <td>
          <a href="#" [pRowToggler]="announcement">
            <i
              [ngClass]="
                expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
              "
            ></i>
          </a>
        </td>
        <td>
          <span>{{ announcement.date | date : dateFormat }}</span>
        </td>
        <td>
          <span>{{ announcement.renewals.length }}</span>
        </td>
        <td>
          <span>{{ announcement.futureAnnouncements.length }}</span>
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-announcement>
      <tr>
        <td colspan="4">
          <div
            *ngIf="announcement?.renewals && announcement?.renewals.length > 0"
          >
            <h6>Ann. renew:</h6>
            <p
              *ngFor="let a of announcement?.renewals"
              style="padding-left: 20px"
            >
              {{ a.announcementId }} - {{ a.title }}<br />{{ a.customerId }} -
              {{ a.customerName }}
            </p>
          </div>
          <div
            *ngIf="
              announcement?.futureAnnouncements &&
              announcement?.futureAnnouncements.length > 0
            "
          >
            <h6>Ann. future:</h6>
            <p
              *ngFor="let a of announcement?.futureAnnouncements"
              style="padding-left: 20px"
            >
              {{ a.announcementId }} - {{ a.title }}<br />{{ a.customerId }} -
              {{ a.customerName }}
            </p>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- <p-column expander="true" styleClass="col-icon" [style]="{width:'35px'}"></p-column>
        <p-column field="date" title="date" header="Date">
            <ng-template let-col let-posting="rowData" pTemplate="body">
                <span>{{posting.date | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column field="renewals" title="Renewal" header="Ann. renew">
            <ng-template let-col let-posting="rowData" pTemplate="body">
                <span>{{posting.renewals.length}}</span>
            </ng-template>
        </p-column>
        <p-column field="future" title="FuturePublishDate" header="Ann. future">
            <ng-template let-col let-posting="rowData" pTemplate="body">
                <span>{{posting.futureAnnouncements.length}}</span>
            </ng-template>
        </p-column>
        <ng-template pTemplate="rowexpansion" let-rowData>
            <div *ngIf="rowData?.renewals && rowData?.renewals.length > 0">
                <h6>Ann. renew:</h6>
                <p *ngFor="let a of rowData?.renewals" style="padding-left:20px">{{a.announcementId}} - {{a.title}}<br>{{a.customerId}} - {{a.customerName}}</p>
            </div>
            <div *ngIf="rowData?.futureAnnouncements && rowData?.futureAnnouncements.length > 0">
                <h6>Ann. future:</h6>
                <p *ngFor="let a of rowData?.futureAnnouncements" style="padding-left:20px">{{a.announcementId}} - {{a.title}}<br>{{a.customerId}} - {{a.customerName}}</p>
            </div>
        </ng-template> -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="4">
          {{ 'message.NoRecordsFound' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
